import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ResolutionsPageUI from './ResolutionsPageUI.js'

class ResolutionsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      resolutions: null,
      esignSubmitted: false,
      esignErrorList: null,
    }
  }

  render() {
    return (
      <ResolutionsPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        resolutions={this.state.resolutions}
        onRefreshClick={this.onRefreshClick}
        onSendEsignClick={this.onSendEsignClick}
        esignSubmitted={this.state.esignSubmitted}
        esignErrorList={this.state.esignErrorList}
        successMsg={this.state.successMsg}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getResolutions(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getResolutions(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/documents/resolutions`,
      cacheKey: CacheKeys.Templates(this.props.match.params.loanId, 'resolutions'),
      callback: this.getResolutionsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getResolutionsCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      resolutions: response.resolutions
    })
  }

  onSendEsignClick = () => {
    if (this.state.esignSubmitted) return
    const loanId = this.props.match.params.loanId
    this.setState({ esignErrorList: null, esignSubmitted: true })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${loanId}/documents/resolutions/esign`,
      this.onSendEsignCallback, {}
    )
  }

  onSendEsignCallback = (response) => {
    this.setState({
      esignErrorList: response.errorList && response.errorList.length > 0 ? response.errorList : null,
      esignSubmitted: false,
      successMsg: response.success,
    })
    if (response.errorList && response.errorList.length === 0) {
      this.onRefreshClick('noBusy')
    }
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Templates(this.props.match.params.loanId, 'resolutions'))
    if (noBusy === 'noBusy') {
      this.getResolutions(context)
    }
    else {
      this.setState({
        resolutions: null,
        errorList: null,
        esignErrorList: null,
        esignSubmitted: false,
        successMsg: null,
      })
      this.getResolutions(context)
    }
  }
}

export default withRouter(ResolutionsPageSF)
